// Drag & drop: the drop target is whatever droppable is under the MOUSE POINTER,
// not wherever the dragged card's centre happens to be (hello-pangea default).
const ptr = { x: null, y: null, on: false };
let overEl = null;
const setOver = (el) => { if (overEl === el) return; overEl?.classList.remove("ptr-over"); overEl = el; el?.classList.add("ptr-over"); };
const dropAt = (x, y) => { for (const el of document.elementsFromPoint(x, y)) { const d = el.closest?.("[data-rfd-droppable-id]"); if (d) return d; } return null; };
const move = (e) => { const t = e.touches?.[0] || e; ptr.x = t.clientX; ptr.y = t.clientY; setOver(dropAt(ptr.x, ptr.y)); };

export const pointerDragStart = () => {
    ptr.x = ptr.y = null; ptr.on = true;
    document.body.classList.add("ptr-dragging");
    window.addEventListener("mousemove", move, true);
    window.addEventListener("touchmove", move, { capture: true, passive: true });
};

// Returns the result with `destination` rewritten to the droppable under the pointer
// (null if the pointer isn't over one). Keeps the library index when it already agrees.
export const pointerDragEnd = (result) => {
    window.removeEventListener("mousemove", move, true);
    window.removeEventListener("touchmove", move, true);
    document.body.classList.remove("ptr-dragging"); setOver(null);
    const had = ptr.on && ptr.x != null; ptr.on = false;
    if (!had) return result;
    const d = dropAt(ptr.x, ptr.y);
    const id = d ? d.getAttribute("data-rfd-droppable-id") : null;
    if (!id) return { ...result, destination: null };
    if (result.destination?.droppableId === id) return result;
    return { ...result, destination: { droppableId: id, index: 0 } };
};

// The desktop auto-scale puts CSS `zoom` on <html>; hello-pangea measures the drag clone in
// screen px, so convert its fixed position / size / translate back into zoomed CSS px.
const num = (v) => (typeof v === "number" ? v : parseFloat(v));
export const zoomDragStyle = (style) => {
    if (!style || style.position !== "fixed") return style;
    const z = parseFloat(getComputedStyle(document.documentElement).zoom) || 1;
    if (z === 1) return style;
    const out = { ...style };
    ["top", "left", "width", "height"].forEach((k) => { if (style[k] != null) out[k] = num(style[k]) / z; });
    if (typeof style.transform === "string") out.transform = style.transform.replace(/translate\(([-\d.]+)px,\s*([-\d.]+)px\)/, (_, x, y) => `translate(${x / z}px, ${y / z}px)`);
    return out;
};
